const baseUrl = `${window.location.protocol}//${window.location.hostname}`

export const environment = {
  API_URL: ['3000', '3001', '3002'].includes(window.location.port) ? baseUrl : `${baseUrl}:${window.location.port}`,
  REACT_URL: `${baseUrl}:${window.location.port}`
}
